export default __webpack_public_path__ + "static/media/Barlow-Regular.952f8963.ttf";